import * as angular from 'angular';
import {policyFromDto, policyToDto} from '../AuthenticationAccessPolicyDTO';
import {timezones} from "../../../../../data/timezones";

export class Controller {
    /** @ngInject */
    constructor($state, Alert, AuthenticationAccessPolicyResource, ConfirmModal) {
        this.$state = $state;
        this.Alert = Alert;
        this.AuthenticationAccessPolicyResource = AuthenticationAccessPolicyResource;
        this.ConfirmModal = ConfirmModal;
    }

    $onInit() {
        this.$policy = policyFromDto(this.policy, this.countries, this.browserTypes, this.osTypes);
        this.timezones = timezones;
        this.handleTimezoneModel= this.timezones.find(a=>a.offsetHour===this.$policy.gmtOffset.hours && a.offsetMin===this.$policy.gmtOffset.mins);
    }

    isInvalid() {
        return (
            !this.$policy.browsers.getSelectedIds().length ||
            !this.$policy.oses.getSelectedIds().length ||
            this.form.$invalid
        );
    }
    handleTimezoneSelect(timezone){
        this.$policy.gmtOffset.hours=timezone.offsetHour*1;
        this.$policy.gmtOffset.mins=timezone.offsetMin*1;
    }

    isLoading() {
        return this.isDeleting || this.isRestoring || this.isSaving;
    }

    notModified() {
        const {$policy, countries, browserTypes, osTypes} = this;
        const {appliedApplications, ...policy} = this.policy;
        return angular.equals(policy, policyToDto($policy, countries, browserTypes, osTypes));
    }

    remove() {
        this.isDeleting = true;
        this.ConfirmModal({
            messageKey:'Do you want to delete this policy?',
            titleKey:'Delete Policy',
            confirmButtonTextKey:'Yes',
        })
            .then(() =>
                this.AuthenticationAccessPolicyResource.deleteAuthenticationAccessPolicy(
                    this.companyId,
                    this.policy.id,
                ),
            )
            .then(() => this.$state.go('^', {}, {reload: '^'}))
            .then(() => this.Alert('success', 'company.policies.authentication-access-policies.removed'))
            .finally(() => (this.isDeleting = false));
    }

    restore() {
        this.isRestoring = true;
        this.ConfirmModal({
            messageKey:'Do you want to restore the policy settings to be the same as the Default Policy?',
            titleKey:'Restore to default',
            confirmButtonTextKey:'Yes',
        })
            .then(() => this.AuthenticationAccessPolicyResource.reset(this.companyId, this.policy.id))
            .then(() => this.$state.reload('company.policies'))
            .then(() => this.Alert('success', 'company.policies.authentication-access-policies.restored'))
            .finally(() => (this.isRestoring = false))
    }

    save() {
        const {$policy, countries, browserTypes, osTypes} = this;
        const policy = policyToDto($policy, countries, browserTypes, osTypes);

        this.isSaving = true;
        this.AuthenticationAccessPolicyResource.updateAuthenticationAccessPolicy(this.companyId, policy)
            .then(() => this.$state.go('^', {}, {reload: '^'}))
            .then(() => this.Alert('success', 'company.policies.authentication-access-policies.saved'))
            .finally(() => (this.isSaving = false));
    }

    saveDisabled() {
        return this.isLoading() || this.isInvalid() || this.notModified();
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/policies/authentication-access-policies/edit-policy/edit-policy.controller.js